import React from 'react'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatNumber } from '../../../../utils/Helpers'

type Props = {
  multipleShoppingCartTicketGrowth: number
}

const MultipleShoppingCartTicketGrowth = ({ multipleShoppingCartTicketGrowth }: Props): JSX.Element => {
  if (!multipleShoppingCartTicketGrowth && multipleShoppingCartTicketGrowth !== 0) return <CardWidgetSkeleton />

  return (
    <CardWidget title={`% ${multipleShoppingCartTicketGrowth >= 0 ? 'Aumento' : 'Descrescimo'} - Ticket`} number={`${formatNumber(multipleShoppingCartTicketGrowth, 2)} %`} color={multipleShoppingCartTicketGrowth >= 0 ? Colors.green : Colors.red} />
  )
}

export default MultipleShoppingCartTicketGrowth
